import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Hoarding, Campaign } from './Instore';



export interface Dashboard {
    state: string
    message: string
    result: DashboardResult
}

export interface DashboardResult {
    all_ads: AllAds;
    new_ads: NewAds;
    live_ads: LiveAds;
    expiry_ads: ExpiryAds;
    upcoming_ads: UpcomingAds;
    expiring_ads: ExpiringAds;
}
export interface ExpiringAds {
    instore: number
    hoarding: number
    campaign: number
}
export interface UpcomingAds {
    instore: number
    hoarding: number
    campaign: number
}
export interface AllAds {
    instore: number
    hoarding: number
    campaign: number
}

export interface NewAds {
    instore: number
    hoarding: number
    campaign: number
}

export interface LiveActivity {
    instore: number
    hoarding: number
    campaign: number
}

export interface ExpiryAds {
    instore: number
    hoarding: number
    campaign: number
}


export interface LiveAds {
    state: string
    message: string
    result: LiveAdsResult
}

export interface LiveAdsResult {
    instore: Instore[]
    hoarding: Hoarding[]
    campaign: Campaign[]
}

export interface Instore {
    id: number
    name: string
    region_id: number
    showroom_id: number
    floor_id: number
    location_id: number
    asset_type_id: number
    creative_id: number
    size_w: number
    size_h: number
    asset_count: number
    install_date: string
    expiry_date: string
    particulars: string
    image: string
    vendor_id: number
    is_installed: number
    is_suspended: number
    is_deleted: number
    is_discontinued: number
    created_by: number
    created_time: number
    modified_by: number
    modified_time: number
    lastChanged: string
    expiryDays: number
    assetTypeName: string
    creativeName: string
    floorName: string
    locationName: string
    regionName: string
    showroomName: string
    vendorName: string
}



export class LoginUser {
    state: string;
    message: string;
    data: LoginData;
}
class LoginData {
    id: number;
    token: string;
    first_name: string;
    last_name: string;
    email: string;
    mobile: string;
    region_id: string;
    region_name: string;
    showroom_id: string;
    showroom_name: string;
    role_id: string;
    role_name: string;
    profile_picture: string;
    is_view: number;
}

export class RoleLists {
    state: string;
    message: string;
    result: RoleInformations[];
}
export class RoleInformations {
    id: string;
    name: string;
    iEnabled: boolean;
    is_suspended: number;
    is_deleted: number;
    created_by: number;
    created_time: number;
    modified_by: number;
    modified_time: number;
}

export class UserLists {
    state: string;
    message: string;
    result: UserInformations[];
}
export class UserInformations {
    email: string;
    id: string;
    password: string;
    first_name: string;
    last_name: string;
    role_id: string;
    mobile: string;
    profile_picture: string;
    is_suspended: number;
    is_deleted: number;
    region_id: number;
    showroom_id: number;
    regionName: string;
    showroomName: string;
    roleName: string;
}

export class PasswordReset {
    state: string;
    message: string;
}
export class ForgotPassword {
    state: string;
    message: string;
    data: string;
}
export class UserRegistration {
    state: string;
    message: string;
}
export class Region {
    state: string;
    message: string;
}
export class RegionLists {
    state: string;
    message: string;
    result: RegionInformations[];
}

export class RegionInformations {
    id: string;
    name: string;
    image: string;
    is_suspended: number;
    is_deleted: number;
    created_by: number;
    created_time: number;
    modified_by: number;
    modified_time: number;
}

export class ExcelRegion {
    ID: string;
    REGION_NAME: string;
}
export class ExcelShowroom {
    ID: string;
    REGION_NAME: string;
    SHOWROOM_NAME: string;
}
export class ExcelAssets {
    ID: string;
    ASSETS_NAME: string;
}
export class ExcelCreative {
    ID: string;
    CREATIVE_NAME: string;
}
export class ExcelVendor {
    ID: string;
    VENDOR_NAME: string;
}
export class ExcelFloor {
    ID: string;
    FLOOR_NAME: string;
}
export class ExcelFloorM {
    REGION_NAME: string;
    SHOWROOM_NAME: string;
    FLOOR_NAME: string;
}
export class ExcelLocation {
    ID: string;
    LOCATION_NAME: string;
}
export class ExcelUser {
    NAME: string;
    DESIGNATION: string;
    REGION: string;
    SHOWROOM: string;
    EMAIL: string;
    PHONE_NUMBER: Number;
}


export class Showroom {
    state: string;
    message: string;
}
export class ShowroomLists {
    state: string;
    message: string;
    result: ShowroomInformations[];
}
export class ShowroomInformations {
    id: string;
    name: string;
    image: string;
    floor_ids: string;
    is_suspended: number;
    is_deleted: number;
    created_by: number;
    created_time: number;
    modified_by: number;
    modified_time: number;
    regionName: string;
    region_id: number;
    code: string;
}

export class FestivalLists {
    state: string;
    message: string;
    result: ShowroomInformations[];
}
export class FestivalInformations {
    id: string;
    name: string;
    start_date: string;
    end_date: string;
    is_suspended: number;
    is_deleted: number;
    created_by: number;
    created_time: number;
    modified_by: number;
    modified_time: number;
}

export class Floor {
    state: string;
    message: string;
}
export class FloorLists {
    state: string;
    message: string;
    result: FloorInformations[];
}
export class FloorInformations {
    id: string;
    name: string;
    code: string;
    image: string;
    is_suspended: number;
    is_deleted: number;
    created_by: number;
    created_time: number;
    modified_by: number;
    modified_time: number;
    isSelected: boolean;
}




export class FloorMappingLists {
    state: string;
    message: string;
    result: FloorMappingInformations[];
}
export class FloorMappingInformations {
    floor_ids: string;
    showroom_name: string;
    region_name: string;
    showroom_id: number;
    region_id: number;
}

export class Assets {
    state: string;
    message: string;
}
export class AssetsLists {
    state: string;
    message: string;
    result: AssetsInformations[];
}
export class AssetsInformations {
    id: string;
    name: string;
    image: string;
    is_suspended: number;
    is_deleted: number;
    created_by: number;
    created_time: number;
    modified_by: number;
    modified_time: number;
}
export class Creative {
    state: string;
    message: string;
}
export class CreativeLists {
    state: string;
    message: string;
    result: CreativeInformations[];
}
export class CreativeInformations {
    id: string;
    name: string;
    image: string;
    is_suspended: number;
    is_deleted: number;
    created_by: number;
    created_time: number;
    modified_by: number;
    modified_time: number;
}
export class Vendor {
    state: string;
    message: string;
}
export class VendorLists {
    state: string;
    message: string;
    result: VendorInformations[];
}
export class VendorInformations {
    id: string;
    name: string;
    image: string;
    is_suspended: number;
    is_deleted: number;
    created_by: number;
    created_time: number;
    modified_by: number;
    modified_time: number;
}
export class Location_ {
    state: string;
    message: string;
}

export class Campaign_ {
    state: string;
    message: string;
}
export class LocationLists {
    state: string;
    message: string;
    result: FloorInformations[];
}
export class LocationInformations {
    id: string;
    name: string;
    image: string;
    is_suspended: number;
    is_deleted: number;
    created_by: number;
    created_time: number;
    modified_by: number;
    modified_time: number;
}
export class LocationMappingLists {
    state: string;
    message: string;
    result: FloorInformations[];
}
export class LocationMappingInformations {
    floor_id: string;
    showroom_name: string;
    region_name: string;
    showroom_id: number;
    region_id: number;
    floor_name: string;
    location_ids: string;

}
export interface CampaignMappingLists {
    state: string
    message: string
    result: CampaignMappingInformation[]
}

export interface CampaignMappingInformation {
    region_id: number
    region_name: string
    showroom_id: number
    showroom_name: string
    festival_ids: string
}

export interface CampaignLists {
    state: string;
    message: string;
    result: CampaignInformation[];
}

export interface CampaignInformation {
    id: number;
    name: string;
    start_date: Date;
    end_date: Date;
    is_suspended: number;
    is_deleted: number;
    created_by: number;
    created_time: number;
    modified_by: number;
    modified_time: number;
}

export class DeleteUser {
    state: string;
    message: string;
    result: CampaignInformation[];
}

@Injectable({ providedIn: 'root' })
export class AccountService {
    private REST_API_SERVER = "https://brandmonitoringapp.grtjewels.com";
    // private REST_API_SERVER = "http://172.16.200.74:3001";
    // private REST_API_SERVER = "http://localhost:3000";
    constructor(private router: Router, private http: HttpClient) { }

    getDashboardData(showroomID) {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json',  'Authorization': 'Bearer ' + authToken })
        let params = new HttpParams().set('showroom_id', showroomID).set("new_days", "7");
        return this.http.get<Dashboard>(this.REST_API_SERVER + '/api/dashboard', { headers: headers, params: params });
    }

    getLiveAds(showroomID) {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })
        let params = new HttpParams().set('showroom_id', showroomID);
        return this.http.get<LiveAds>(this.REST_API_SERVER + '/api/dashboard/liveads', { headers: headers, params: params });
    }


    getNewAds(showroomID) {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })
        let params = new HttpParams().set('showroom_id', showroomID);
        return this.http.get<LiveAds>(this.REST_API_SERVER + '/api/dashboard/newads', { headers: headers, params: params });
    }

    getExpiryAds(showroomID) {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })
        let params = new HttpParams().set('showroom_id', showroomID);
        return this.http.get<LiveAds>(this.REST_API_SERVER + '/api/dashboard/expiryads', { headers: headers, params: params });
    }

    getUpcomingAds(showroomID) {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })
        let params = new HttpParams().set('showroom_id', showroomID);
        return this.http.get<LiveAds>(this.REST_API_SERVER + '/api/dashboard/upcomingads', { headers: headers, params: params });
    }



    logout() {
        localStorage.removeItem('user');
        this.router.navigate(['/account/login']);
    }

    userLogin(email: string, password: string) {
        return this.http.post<LoginUser>(this.REST_API_SERVER + '/api/user/login', { "email": email, "password": password });
    }
    forgotpassword(email: string) {
        return this.http.post<LoginUser>(this.REST_API_SERVER + '/api/user/forgotpassword', { "email": email });
    }



    /* ********************* SURENDIRAN********************* */

    updatepassword(email: string, password: string) {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + authToken })
        return this.http.post<PasswordReset>(this.REST_API_SERVER + `/api/user/updatepassword`, { "email": email, "password": password }, { headers: headers });
    }




    getUserRoleLists() {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })
        return this.http.get<RoleLists>(this.REST_API_SERVER + '/api/role', { headers: headers });
    }


    /* ********************* USER MANAGEMENT********************* */

    /* ********************* USER ********************* */
    getUserLists() {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })
        return this.http.get<UserLists>(this.REST_API_SERVER + '/api/user', { headers: headers });
    }

    changepassword(formdata: FormData) {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + authToken })
        return this.http.post<UserRegistration>(this.REST_API_SERVER + `/api/user/changepassword`, formdata, { headers: headers });
    }

    updateUserData(formdata: FormData) {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + authToken })
        return this.http.post<UserRegistration>(this.REST_API_SERVER + `/api/user/update`, formdata, { headers: headers });
    }
    addUserData(formdata: FormData) {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + authToken })
        return this.http.post<UserRegistration>(this.REST_API_SERVER + `/api/user/add`, formdata, { headers: headers });
    }

    suspendUser(id: string, is_suspended: string) {
        let authToken = localStorage.getItem('authtoken');
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                
                'Authorization': 'Bearer ' + authToken
            }),
            body: {
                "user_id": id,
                "is_suspended": is_suspended
            }
        }

        return this.http.delete<Region>(this.REST_API_SERVER + '/api/user/suspend', options);
    }

    /* ********************* USER ********************* */

    /* ********************* REGION ********************* */


    addRegion(formdata: FormData) { // region_name: string,image:string
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + authToken })
        return this.http.post<Region>(this.REST_API_SERVER + `/api/region/add`, formdata, { headers: headers });

    }




    updateRegion(formdata: FormData) {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + authToken })
        return this.http.post<Region>(this.REST_API_SERVER + `/api/region/update`, formdata, { headers: headers });
    }

    getRegionsLists() {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })
        return this.http.get<RegionLists>(this.REST_API_SERVER + '/api/region/',
            { headers: headers });
    }

    suspendRegion(regionID: string, isSuspendedID: string) {

        let authToken = localStorage.getItem('authtoken');
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                
                'Authorization': 'Bearer ' + authToken
            }),
            body: {
                "region_id": regionID,
                "is_suspended": isSuspendedID
            }
        }

        return this.http.delete<Region>(this.REST_API_SERVER + '/api/region/suspend', options)
    }


    deleteRegion(regionID: string, isDeleteID: number) {

        let authToken = localStorage.getItem('authtoken');
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                
                'Authorization': 'Bearer ' + authToken
            }),
            body: {
                "region_id": regionID,
                "is_deleted": isDeleteID
            }
        }

        return this.http.delete<Region>(this.REST_API_SERVER + '/api/region/delete', options)
    }
    /* ********************* REGION ********************* */


    /* ********************* SHOWROOM ********************* */

    addShowroom(formdata: FormData) {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + authToken })

        return this.http.post<Showroom>(this.REST_API_SERVER + `/api/showroom/add`, formdata, { headers: headers });

    }




    updateShowroom(formdata: FormData) {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + authToken })

        return this.http.post<Showroom>(this.REST_API_SERVER + `/api/showroom/update`, formdata, { headers: headers });
    }

    getShowroomLists() {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })

        return this.http.get<ShowroomLists>(this.REST_API_SERVER + '/api/showroom/', { headers: headers });
    }
    suspendShowroom(showroomId: string, isSuspendedID: string) {
        let authToken = localStorage.getItem('authtoken');
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                
                'Authorization': 'Bearer ' + authToken
            }),
            body: {
                "showroom_id": showroomId,
                "is_suspended": isSuspendedID
            }
        }
        return this.http.delete<Showroom>(this.REST_API_SERVER + '/api/showroom/suspend', options);
    }

    deleteShowroom(showroom_id: string, isDeleteID: number) {

        let authToken = localStorage.getItem('authtoken');
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                
                'Authorization': 'Bearer ' + authToken
            }),
            body: {
                "showroom_id": showroom_id,
                "is_deleted": isDeleteID
            }
        }

        return this.http.delete<Showroom>(this.REST_API_SERVER + '/api/showroom/delete', options)
    }

    deleteUser(deleteData: any) {

        let authToken = localStorage.getItem('authtoken');
        var userdata = localStorage.getItem('userInformation');
        var parsedUserData = JSON.parse(userdata);
        const headers= new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authToken
            });
           const reqBody= {
                "logginUser": parsedUserData.id,
                "user_id":deleteData.id
            }
        return this.http.post<DeleteUser>(this.REST_API_SERVER + `/api/user/delete`, reqBody, { headers: headers });
    }


    /* ********************* SHOWROOM ********************* */

    /*********** Festival */
    getFestivalLists() {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })

        return this.http.get<FestivalLists>(this.REST_API_SERVER + '/api/festival/', { headers: headers });
    }
    getShowroomFestivalLists(showroomID) {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })
        let params = new HttpParams().set('showroom_id', showroomID);
        return this.http.get<FestivalLists>(this.REST_API_SERVER + '/api/festival/', { params: params, headers: headers });

    }

    /****** End Festival */

    /* ********************* ASSETS ********************* */


    addAssets(assets_name: string) {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })

        return this.http.post<Assets>(this.REST_API_SERVER + `/api/assettype/add`, {
            "name": assets_name,
            "image": ""
        }, { headers: headers });

    }

    updateAssets(assets_id: string, assets_name: string) {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })

        return this.http.post<Assets>(this.REST_API_SERVER + `/api/assettype/update`, {
            "asset_type_id": assets_id,
            "name": assets_name,
            "image": ""
        }, { headers: headers });
    }

    getAssetsLists() {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })

        return this.http.get<AssetsLists>(this.REST_API_SERVER + '/api/assettype/', { headers: headers });
    }

    suspendAssets(asset_type_id: string, isSuspendedID: string) {
        let authToken = localStorage.getItem('authtoken');
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                
                'Authorization': 'Bearer ' + authToken
            }),
            body: {
                "asset_type_id": asset_type_id,
                "is_suspended": isSuspendedID
            }
        }
        return this.http.delete<Assets>(this.REST_API_SERVER + '/api/assettype/suspend', options);
    }


    deleteAssets(asset_type_id: string, isDeleteID: number) {

        let authToken = localStorage.getItem('authtoken');
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                
                'Authorization': 'Bearer ' + authToken
            }),
            body: {
                "asset_type_id": asset_type_id,
                "is_deleted": isDeleteID
            }
        }

        return this.http.delete<Assets>(this.REST_API_SERVER + '/api/assettype/delete', options)
    }




    /* ********************* ASSETS ********************* */



    /* ********************* Creative ********************* */


    addCreative(creative_name: string) {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })

        return this.http.post<Creative>(this.REST_API_SERVER + `/api/creative/add`, {
            "name": creative_name,
            "image": ""
        }, { headers: headers });
    }

    updateCreative(creative_id: string, creative_name: string) {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })

        return this.http.post<Creative>(this.REST_API_SERVER + `/api/creative/update`, {
            "creative_id": creative_id,
            "name": creative_name,
            "image": ""
        }, { headers: headers });
    }

    getCreativeLists() {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })

        return this.http.get<CreativeLists>(this.REST_API_SERVER + '/api/creative/', { headers: headers });
    }
    suspendCreative(creative_id: string, isSuspendedID: string) {
        let authToken = localStorage.getItem('authtoken');
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                
                'Authorization': 'Bearer ' + authToken
            }),
            body: {
                "creative_id": creative_id,
                "is_suspended": isSuspendedID
            }
        }
        return this.http.delete<Creative>(this.REST_API_SERVER + '/api/creative/suspend', options);
    }

    deleteCreative(creative_id: string, isDeleteID: number) {

        let authToken = localStorage.getItem('authtoken');
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                
                'Authorization': 'Bearer ' + authToken
            }),
            body: {
                "creative_id": creative_id,
                "is_deleted": isDeleteID
            }
        }

        return this.http.delete<Creative>(this.REST_API_SERVER + '/api/creative/delete', options)
    }


    /* ********************* Creative ********************* */

    /* ********************* vendor ********************* */


    addVendor(vendor_name: string) {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })

        return this.http.post<Vendor>(this.REST_API_SERVER + `/api/vendorgrt/add`, {
            "name": vendor_name
        }, { headers: headers });

    }

    updateVendor(vendor_id: string, vendor_name: string) {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })

        return this.http.post<Vendor>(this.REST_API_SERVER + `/api/vendorgrt/update`, {
            "vendor_id": vendor_id,
            "name": vendor_name
        }, { headers: headers });
    }

    getVendorLists() {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })

        return this.http.get<VendorLists>(this.REST_API_SERVER + '/api/vendorgrt/', { headers: headers });
    }
    suspendVendor(vendor_id: string, isSuspendedID: string) {
        let authToken = localStorage.getItem('authtoken');
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authToken
            }),
            body: {
                "vendor_id": vendor_id,
                "is_suspended": isSuspendedID
            }
        }
        return this.http.delete<Vendor>(this.REST_API_SERVER + '/api/vendorgrt/suspend', options);
    }

    deleteVendor(vendor_id: string, isDeleteID: number) {

        let authToken = localStorage.getItem('authtoken');
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authToken
            }),
            body: {
                "vendor_id": vendor_id,
                "is_deleted": isDeleteID
            }
        }

        return this.http.delete<Vendor>(this.REST_API_SERVER + '/api/vendorgrt/delete', options)
    }

    /* ********************* vendor ********************* */



    /* ********************* FLOOR ********************* */


    addFloor(floorname: string) {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })

        return this.http.post<Floor>(this.REST_API_SERVER + `/api/floor/add`, {
            "name": floorname,
            "image": ""
        }, { headers: headers });

    }

    updateFloor(floor_id: string, floor_name: string) {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })

        return this.http.post<Assets>(this.REST_API_SERVER + `/api/floor/update`, {
            "floor_id": floor_id,
            "name": floor_name,
            "image": ""
        }, { headers: headers });
    }

    getFloorLists() {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })
        return this.http.get<FloorLists>(this.REST_API_SERVER + '/api/floor', { headers: headers });
    }
    getFloorMappingsLists() {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })
        return this.http.get<FloorMappingLists>(this.REST_API_SERVER + '/api/floor/mappings', { headers: headers });
    }

    suspendFloor(floor_id: string, isSuspendedID: string) {
        let authToken = localStorage.getItem('authtoken');
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authToken
            }),
            body: {
                "floor_id": floor_id,
                "is_suspended": isSuspendedID
            }
        }
        return this.http.delete<Floor>(this.REST_API_SERVER + '/api/floor/suspend', options);
    }


    deleteFloor(floor_id: string, isDeleteID: number) {

        let authToken = localStorage.getItem('authtoken');
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                
                'Authorization': 'Bearer ' + authToken
            }),
            body: {
                "floor_id": floor_id,
                "is_deleted": isDeleteID
            }
        }

        return this.http.delete<Floor>(this.REST_API_SERVER + '/api/floor/delete', options)
    }




    /* ********************* Floor ********************* */


    /* ********************* Floor Mapping ********************* */
    addFloorMapping(regionID: number, showroomID: number, selectedFloor) {
        var floorIDs = selectedFloor.toString();

        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })
        return this.http.post<FloorMappingLists>(this.REST_API_SERVER + `/api/floor/assign`, {
            "region_id": regionID,
            "showroom_id": showroomID,
            "floor_ids": floorIDs
        }, { headers: headers });

    }

    /* ********************* Floor Mapping ********************* */

    /* ********************* LOCATION ********************* */
    addLocationMapping(regionID: number, showroomID: number, floorID: number, selectedLocation) {
        var locationIDS = selectedLocation.toString();

        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })
        return this.http.post<FloorMappingLists>(this.REST_API_SERVER + `/api/location/assign`, {
            "region_id": regionID,
            "showroom_id": showroomID,
            "floor_id": floorID,
            "location_ids": locationIDS
        }, { headers: headers });

    }

    addLocation(locationName: string) {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })

        return this.http.post<Location_>(this.REST_API_SERVER + `/api/location/add`, {
            "name": locationName,
            "image": ""
        }, { headers: headers });

    }

    updateLocation(location_id: string, location_name: string) {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })

        return this.http.post<Location_>(this.REST_API_SERVER + `/api/location/update`, {
            "location_id": location_id,
            "name": location_name,
            "image": ""
        }, { headers: headers });
    }


    getLocationLists() {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })

        return this.http.get<LocationLists>(this.REST_API_SERVER + '/api/location/', { headers: headers });
    }


    getLocationMappingLists(regionID, showroomID, floorID) {

        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })
        let params = new HttpParams().set('region_id', regionID).set('showroom_id', showroomID).set('floor_id', floorID);
        return this.http.get<LocationMappingLists>(this.REST_API_SERVER + '/api/location/mappings/', { params: params, headers: headers });
    }

    suspendLocation(location_id: string, isSuspendedID: string) {
        let authToken = localStorage.getItem('authtoken');
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                
                'Authorization': 'Bearer ' + authToken
            }),
            body: {
                "location_id": location_id,
                "is_suspended": isSuspendedID
            }
        }
        return this.http.delete<Location_>(this.REST_API_SERVER + '/api/location/suspend', options);
    }


    getFloorLocationLists(regionID, showroomID, floorID) {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })
        let params = new HttpParams().set('region_id', regionID).set('showroom_id', showroomID).set('floor_id', floorID);
        return this.http.get<LocationLists>(this.REST_API_SERVER + '/api/location/', { params: params, headers: headers });
    }

    deleteLocation(location_id: string, isDeleteID: number) {

        let authToken = localStorage.getItem('authtoken');
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                
                'Authorization': 'Bearer ' + authToken
            }),
            body: {
                "location_id": location_id,
                "is_deleted": isDeleteID
            }
        }

        return this.http.delete<Location_>(this.REST_API_SERVER + '/api/location/delete', options)
    }

    /* ********************* campaign ********************* */

    addCamapignMapping(regionID: number, showroomID: number, selectedCampaign) {
        var festival_ids = selectedCampaign.toString();

        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })
        return this.http.post<FloorMappingLists>(this.REST_API_SERVER + `/api/festival/assign`, {
            "region_id": regionID,
            "showroom_id": showroomID,
            "festival_ids": festival_ids
        }, { headers: headers });

    }
    getCampaignMappingLists(regionID, showroomID) {

        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })
        let params = new HttpParams().set('region_id', regionID).set('showroom_id', showroomID);
        return this.http.get<CampaignMappingLists>(this.REST_API_SERVER + '/api/festival/mappings/', { params: params, headers: headers });
    }
    addCampaign(formData: FormData) {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + authToken })

        return this.http.post<Campaign_>(this.REST_API_SERVER + `/api/festival/add`, formData, { headers: headers });

    }

    updateCampaign(formData: FormData) {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + authToken })

        return this.http.post<Campaign_>(this.REST_API_SERVER + `/api/festival/update`, formData, { headers: headers });
    }

    getCampaignLists() {
        let authToken = localStorage.getItem('authtoken');
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authToken })
        return this.http.get<CampaignLists>(this.REST_API_SERVER + '/api/festival/', { headers: headers });
    }

    suspendCampaign(festival_id: string, isSuspendedID: string) {
        let authToken = localStorage.getItem('authtoken');
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                
                'Authorization': 'Bearer ' + authToken
            }),
            body: {
                "festival_id": festival_id,
                "is_suspended": isSuspendedID
            }
        }
        return this.http.delete<Campaign_>(this.REST_API_SERVER + '/api/festival/suspend', options);
    }


    deleteCampaign(festival_id: string, isDeleteID: number) {

        let authToken = localStorage.getItem('authtoken');
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                
                'Authorization': 'Bearer ' + authToken
            }),
            body: {
                "festival_id": festival_id,
                "is_deleted": isDeleteID
            }
        }

        return this.http.delete<Campaign_>(this.REST_API_SERVER + '/api/festival/delete', options)
    }


    /* ********************* campaign ********************* */

    /* ********************* Floor ********************* */



    /*getLocationLists() {
        let authToken = localStorage.getItem('authtoken');   
        console.log("getUserLists token "+authToken);
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+authToken
            })
        return this.http.get<LocationLists>(this.REST_API_SERVER +'/api/location/', { headers: headers });
    }  */

    /* ********************* USER MANAGEMENT********************* */

    compare(a, b, isAsc) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }


    /* ********************* SURENDIRAn********************* */
}